var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.306 5.305v3.638a8.72 8.72 0 0 1-1.56 1.449V5.305a1.745 1.745 0 0 0-3.491 0v10.977a3.303 3.303 0 0 1-1.56-2.807v-8.17a3.305 3.305 0 0 1 6.611 0zm7.612 8.21-3.151 1.82a8.71 8.71 0 0 1-2.035-.628l4.406-2.543a1.745 1.745 0 1 0-1.746-3.023l-9.509 5.49a3.3 3.3 0 0 1 1.652-2.755l7.077-4.085a3.306 3.306 0 0 1 3.306 5.725zM23.612 24.21l-3.151-1.82a8.688 8.688 0 0 1-.474-2.074l4.406 2.543a1.746 1.746 0 0 0 1.746-3.024l-9.509-5.488a3.304 3.304 0 0 1 3.211.053l7.078 4.086a3.304 3.304 0 1 1-3.306 5.724zm-10.917 2.485v-3.638a8.717 8.717 0 0 1 1.56-1.448v5.085a1.745 1.745 0 0 0 3.491 0V15.718a3.303 3.303 0 0 1 1.56 2.807v8.17a3.305 3.305 0 0 1-6.611 0zm-7.611-8.21 3.15-1.82a8.71 8.71 0 0 1 2.036.628l-4.406 2.543a1.745 1.745 0 1 0 1.745 3.023l9.508-5.49a3.3 3.3 0 0 1-1.652 2.755L8.39 24.21a3.306 3.306 0 0 1-3.306-5.725zM8.389 7.79l3.15 1.82c.243.668.402 1.366.475 2.075L7.61 9.14a1.746 1.746 0 0 0-1.747 3.024l9.51 5.489c-.974.52-2.186.54-3.213-.053l-7.076-4.085A3.304 3.304 0 1 1 8.389 7.79z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDent);
export default __webpack_public_path__ + "static/media/DENT.92c719b80211701e762e2a8fb05a572c.svg";
export { ForwardRef as ReactComponent };